import Vue from 'vue';
export default Vue.component('ed-add-menu-options', {
  name: 'ed-add-menu-options',
  props: ['options', 'selectOption'],
  methods: {
    selected(i) {
      this.$emit('selectOption', i);
    }
  }
});